import { atomWithCookie } from './atomWithCookie';

/**
 * Global atom for managing side navigation expanded state
 * Persists user preference in a cookie across sessions
 */
export const sideNavExpandedAtom = atomWithCookie<boolean>('sideNavExpanded', true);
